import cn from "classnames";
import { Overlay } from "../overlay";
import { DialogBase } from "./components/dialog-base";
import { DialogFullscreen } from "./components/dialog-fullscreen";
import { useOverlayAnimation } from "./hooks";
import { DEFAULT_TRANSITION_DURATION } from "./constants";
import { DialogProps } from "./types";
import styles from "./styles.module.scss";

export const Dialog = ({
  size,
  title,
  footer,
  children,
  className,
  fullscreen,
  opened = false,
  autofocus = true,
  dataTestId = "dialog",
  showCloseIcon = true,
  onBack,
  onExit,
  onEnter,
  onClose,
  onExited,
  onEntered,
  transitionDuration = DEFAULT_TRANSITION_DURATION,
  transitionName = "fade",
  ...restProps
}: DialogProps) => {
  const {
    handleExit,
    handleEnter,
    handleExited,
    handleEntered,
    animationClassNames,
  } = useOverlayAnimation({
    onExit,
    onEnter,
    onExited,
    onEntered,
  });

  const commonProps = {
    onClose,
    children,
    dataTestId,
    className: cn(className, {
      [animationClassNames]: transitionName !== null,
    }),
    showCloseIcon,
  };

  return (
    <Overlay
      fixed
      opened={opened}
      transitionName={transitionName}
      autofocus={autofocus}
      dataTestId={dataTestId}
      shouldPreventBodyScroll
      shouldCloseByEscapePress
      shouldCloseByBackdropClick
      className={cn(styles.backdrop, { [styles.fullscreen]: fullscreen })}
      transitionDuration={transitionDuration}
      onClose={onClose}
      onExit={handleExit}
      onEnter={handleEnter}
      onExited={handleExited}
      onEntered={handleEntered}
      {...restProps}
    >
      {fullscreen ? (
        <DialogFullscreen
          {...commonProps}
          title={title}
          footer={footer}
          onBack={onBack}
        />
      ) : (
        <DialogBase {...commonProps} size={size} />
      )}
    </Overlay>
  );
};
